import { FocusZoneDirection } from '../../focusZone/types';

/**
 * @specification
 * Adds role='menu'.
 * Provides arrow key navigation in bidirectionalDomOrder direction.
 */
export var navigableListBehavior = function navigableListBehavior(props) {
  return {
    attributes: {
      root: {
        role: 'menu'
      }
    },
    focusZone: {
      props: {
        shouldFocusInnerElementWhenReceivedFocus: true,
        direction: FocusZoneDirection.bidirectionalDomOrder
      }
    }
  };
};
//# sourceMappingURL=navigableListBehavior.js.map
